import PropTypes from 'prop-types';
import { Link } from 'gatsby';
import { renderRichText } from 'gatsby-source-contentful/rich-text';

import ImageDisplay from '../imageDisplay';

const TileContainer = ({ paddingBottom, subHeading, tiles }) => {
	const paddingBottomMap = {
		Medium: 'tile-container--bottom--md',
		Small: 'tile-container--bottom--sm',
		None: '',
	};
	return (
		<div className={`section tile-container ${paddingBottomMap[paddingBottom]}`}>
			<div className="section__content tile-container__content">
				{Boolean(subHeading) && (
					<h2 className="typography typography--h2 typography--secondary">
						{subHeading}
					</h2>
				)}
				<div className="tile-container__items">
					{tiles.map(({ title, titleVariant, icon, description, cta }) => {
						const mapTitleStyle = {
							Primary: 'typography typography--h3 typography--black',
							Secondary: 'typography typography--h5 typography--secondary',
						};
						return (
							<div className="tile-container__item" key={title}>
								{Boolean(icon) && (
									<figure className="tile-container__item__icon">
										<ImageDisplay
											alt={icon?.description}
											image={icon?.gatsbyImageData}
											src={icon?.file?.url}
										/>
									</figure>
								)}
								<h3
									className={`element-title ${mapTitleStyle[titleVariant]}`}
								>
									{title}
								</h3>
								<div className="element-body typography typography--body typography--tertiary">
									{renderRichText(description)}
								</div>
								{cta && (
									<Link className="btn btn--secondary" to={cta?.link}>
										{cta?.title}
									</Link>
								)}
							</div>
						);
					})}
				</div>
			</div>
		</div>
	);
};

TileContainer.propTypes = {
	paddingBottom: PropTypes.oneOf('Medium', 'Small', 'None').isRequired,
	subHeading: PropTypes.string,
	tiles: PropTypes.arrayOf(
		PropTypes.shape({
			icon: PropTypes.shape({
				description: PropTypes.string,
				gatsbyImageData: PropTypes.object,
				file: PropTypes.shape({
					url: PropTypes.string,
				}),
			}),
			title: PropTypes.string.isRequired,
			titleVariant: PropTypes.oneOf(['Primary', 'Secondary']).isRequired,
			subtitle: PropTypes.shape({
				raw: PropTypes.string,
			}),
			cta: PropTypes.shape({
				link: PropTypes.string,
				title: PropTypes.string,
			}),
		})
	),
};

TileContainer.defaultProps = {
	subHeading: null,
	tiles: [],
};

export default TileContainer;
